import { useSelector } from 'react-redux';
/**
 * Provides access to the currently selected article in the ghost model.
 *
 * ```js
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 *  // example store state
 * {
 *   ghost: {
 *     byId: {
 *       'slug-1': { id: 1, slug: 'slug-1', title: 'Article 1' },
 *       'slug-2': { id: 2, slug: 'slug-2', title: 'Article 2' },
 *     },
 *     selected: 'slug-2',
 *   },
 * }
 *
 * const Test = () => {
 *   const article = ghost.hooks.useSelectedArticle();
 *
 *   console.log(article);
 *   // { id: 2, slug: 'slug-2', title: 'Article 2' }
 *
 *   return <div>Test</div>;
 * }
 * ```
 *
 * @returns {Object} - The currently selected article
 */

var useSelectedArticle = function useSelectedArticle() {
  return useSelector(function (state) {
    return state.ghost.byId[state.ghost.selected];
  });
};

export default useSelectedArticle;